import authService from '../../../services/authService';
import type {
  AccountHolderDetailsResponse,
  AccountHoldersListResponse,
  AccountHoldersQuery,
} from '../../../types/features/accountHolders';

const accountHoldersService = {
  getAccountHolders: async ({
    page,
    pageSize,
    search,
    includeWithoutStores,
    activeSubscriptionOnly,
    excludeActiveSubscriptions,
    phoneVerifiedOnly,
  }: AccountHoldersQuery): Promise<AccountHoldersListResponse> => {
    const response = await authService.getStoreOwners({
      page,
      page_size: pageSize,
      search: search?.trim() || null,
      include_without_stores: includeWithoutStores,
      active_subscription_only: activeSubscriptionOnly,
      exclude_active_subscriptions: excludeActiveSubscriptions,
      phone_verified_only: phoneVerifiedOnly,
    });
    return response;
  },

  getAccountHolderDetails: async (holderId: string): Promise<AccountHolderDetailsResponse> => {
    const response = await authService.getStoreOwnerStores(holderId);
    return response;
  },

  deleteAccountHolderLead: async (holderId: string): Promise<void> => {
    await authService.deleteUserWithoutStores(holderId);
  },
};

export default accountHoldersService;
